'use es6';

import { Iterable, Seq } from 'immutable';
import { keySeq } from './TransmuteCollection';

var jsToKeySeq = function jsToKeySeq(subject) {
  return Seq(subject).keySeq();
};

keySeq.implement(Array, jsToKeySeq);
keySeq.implementInherited(Iterable, function (subject) {
  return subject.keySeq();
});
keySeq.implement(Object, jsToKeySeq);
export default keySeq;